import { render, staticRenderFns } from "./Shablon.vue?vue&type=template&id=7fc0aa21"
import script from "./Shablon.vue?vue&type=script&lang=js"
export * from "./Shablon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports